<template>
    <div>
        <Top />
        <Navs />
        <router-view />
        <Bottom />
    </div>
</template>
  
<script>
import Top from '@/components/common/Top.vue'
import Bottom from '@/components/common/Bottom.vue'
import Navs from '@/components/common/Navs.vue'
export default {
    name: 'Main',
    components: {
        Top,
        Bottom,
        Navs
    }
    
}
</script>
<style>

</style>
  